import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { NgIconWrapperComponent } from '../icons/ng-icon-wrapper/ng-icon-wrapper.component';
import { icons } from '../../icon.config';

@Component({
    selector: 'app-dialog',
    imports: [NgIconWrapperComponent],
    templateUrl: './dialog.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class DialogComponent {
  @Input() icon: keyof typeof icons = 'heroCheckSolid';

  @Input() color: 'red' | 'green' | 'blue' | 'orange' = 'green';
  @Input() title!: string;
  @Input() description!: string;
  @Input() actionText!: string;
  @Output() actionClicked = new EventEmitter();
}
